module.exports = __webpack_public_path__ + "static/media/22.75653cf3.png";